import React, { useEffect, useState } from "react";

function Home() {
    const [sweeping, setSweeping] = useState(false);
    const [sliding, setSliding] = useState(false);

    useEffect(() => {
        const sweepTimer = setTimeout(() => setSweeping(true), 3500);
        const slideTimer = setTimeout(() => setSliding(true), 3800);
        return () => {
            clearTimeout(sweepTimer);
            clearTimeout(slideTimer);
        };
    }, []);

    return (
        <div className="slides-wrapper">
            <div className={`hero ${sliding ? "hero-slide-up" : ""}`}>
                <img src="/intro3.gif" alt="intro" className="hero-gif" />
                <div className="hero-tagline">Student. Advocate. Leader.</div>
                <div className={`hero-sweep ${sweeping ? "hero-sweep-in" : ""}`} />
            </div>
            <div className="screen-two" />
        </div>
    );
}

export default Home;
